let UTILS = require("../libs/utils.js");
var v7696;
var v7697;
module.exports = {
  id: "gun",
  name: "Gun Game",
  alias: "gun",
  party: true,
  randClassScr: 0.5,
  tag: ["Party", "#ffac00", "#ffb600"],
  endStats: ["sid", "name", "weapon", "kills", "melees", "setbacks", "reward"],
  description: "Kill other players to progress through every gun in the game. Do it with all guns to win",
  descriptionLang: "game.mode.gun.description",
  leaderStats: ["weaponTier", "kills"],
  leaderSort: function (p9098, p9099) {
    if (p9098.weaponTier === p9099.weaponTier && p9098.kills && p9099.kills) {
      return p9098.kills - p9099.kills;
    } else {
      return p9099.weaponTier - p9098.weaponTier;
    }
  },
  endSort: function (p9100, p9101) {
    if (p9100.weaponTier === p9101.weaponTier && p9100.kills && p9101.kills) {
      return p9100.kills - p9101.kills;
    } else {
      return p9101.weaponTier - p9100.weaponTier;
    }
  },
  winCondition: function (game) {
    var vLN01187 = 0;
    var v7698 = null;
    for (var vLN01188 = 0; vLN01188 < game.players.list.length; ++vLN01188) {
      if (v7698 == null || game.players.list[vLN01188].weaponTier > vLN01187) {
        vLN01187 = game.players.list[vLN01188].weaponTier;
        v7698 = game.players.list[vLN01188];
      }
    }
    if (vLN01187 == 0) {
      return null;
    } else {
      return v7698;
    }
  },
  condition: [function (game) {
    for (var vLN01189 = 0; vLN01189 < game.players.list.length; ++vLN01189) {
      if (game.players.list[vLN01189].weaponTier >= game.mode.weaponOrder.length) {
        return false;
      }
    }
    return true;
  }],
  onKill: function (game, p9105, p9106, p9107, p9108) {
    var v7699 = p9108 && p9108.stk != null;
    if (p9107 && p9107 != p9106) {
      if (!v7699) {
        if (game.weaponConfig[p9108.wId == null ? p9107.loadout[p9107.loadoutIndex] : p9108.wId].melee) {
          game.decreaseWeapon(p9106);
          if (p9107.weaponTier == game.mode.weaponOrder.length - 1) {
            game.increaseWeapon(p9107, p9108);
          }
        } else {
          game.increaseWeapon(p9107, p9108);
        }
      }
    } else {
      game.decreaseWeapon(p9106);
    }
    if (p9105) {
      game.players.syncLeaders();
    }
  },
  startingLoadout: [2],
  keepLoadout: true,
  noAssists: true,
  minPlayers: 2,
  noWeap: true,
  noPickups: true,
  weaponOrder: [2, 27, 16, 10, 4, 11, 21, 5, 3, 9, 1, 14, 6, 0, 18, 7, 8, 13, 22, 12],
  disabledStreaks: [4, 5, 6]
};